// extracted by css-extract-rspack-plugin
export default {"dialog":"Target-module__dialog___dJ88X","container":"Target-module__container___En33J","containerMobile":"Target-module__containerMobile___F_N8s"};